import type { NavigationLink } from '@/components/molecules/Navigation';

export const headerNavigationLinks: NavigationLink[] = [
  {
    path: '/overview',
    label: 'Overview',
  },
  {
    path: '/workflows',
    label: 'Workflows',
  },
  {
    path: '/workflow-definitions',
    label: 'Workflow Definitions',
  },
  {
    path: '/filters',
    label: 'Case Lists',
  },
  {
    path: '/ui-definitions',
    label: 'UI Definitions',
  },
  {
    path: '/alert-definitions',
    label: 'Alerts Definitions',
  },
];
